import { useMemo } from 'react'
import { buildReports, resultsCsv, rosterCsv } from './gg/ggReports.js'

// Live results/standings reports — the ggReports engine run on the REAL
// tournament (flights, scores, calcutta) instead of sample data, with the same
// CSV exports. Reuses the admin card chrome.
export default function ReportsTab({ tournament }) {
  const reports = useMemo(() => buildReports(tournament || {}), [tournament])
  const download = (name, text) => {
    const blob = new Blob([text], { type: 'text/csv' })
    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob)
    a.download = name
    a.click()
    URL.revokeObjectURL(a.href)
  }

  return (
    <div className="space-y-4">
      <div className="card flex flex-wrap items-center justify-between gap-3">
        <h3 className="font-bold text-lg">Reports — {reports.meta?.tournamentName || tournament?.info?.name || 'Event'}</h3>
        <div className="flex gap-2">
          <button className="btn-secondary text-xs" onClick={() => download('results.csv', resultsCsv(reports))}>⬇ Results CSV</button>
          <button className="btn-secondary text-xs" onClick={() => download('roster.csv', rosterCsv(tournament || {}))}>⬇ Roster CSV</button>
        </div>
      </div>

      {(reports.flights || []).length === 0 ? (
        <div className="card text-center text-gray-500 py-8">No flights/scores yet.</div>
      ) : (
        (reports.flights || []).map((f) => (
          <div key={f.flightId} className="card">
            <h4 className="font-bold mb-2">{f.flightName}</h4>
            <table className="w-full text-sm">
              <thead className="text-xs uppercase text-gray-500 border-b">
                <tr>
                  <th className="text-left py-2 w-10">#</th>
                  <th className="text-left py-2">Team</th>
                  <th className="text-right py-2">Gross</th>
                  <th className="text-right py-2">Vs Par</th>
                  <th className="text-right py-2">Net Vs Par</th>
                </tr>
              </thead>
              <tbody>
                {(f.rows || []).map((r, i) => (
                  <tr key={i} className="border-b last:border-0">
                    <td className="py-2 font-bold text-gray-500">{r.place || i + 1}</td>
                    <td className="py-2 font-semibold">{r.teamName}</td>
                    <td className="py-2 text-right">{r.gross || '—'}</td>
                    <td className="py-2 text-right">{r.vsPar}</td>
                    <td className="py-2 text-right">{r.netVsPar}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))
      )}

      {reports.calcutta && reports.calcutta.pot > 0 ? (
        <div className="card">
          <h4 className="font-bold mb-2">Calcutta Payouts — pot {reports.calcutta.pot}</h4>
          <table className="w-full text-sm">
            <tbody>
              {(reports.calcutta.rows || []).map((r, i) => (
                <tr key={i} className="border-b last:border-0">
                  <td className="py-2">{r.place ? `${r.place}.` : ''} {r.teamName || r.owner || ''}</td>
                  <td className="py-2 text-right font-bold">{r.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  )
}
